import arcoAjuda from "./arco-ajuda.webp";
import arcoAmeaca from "./arco-ameaca.webp";
import { CARDS_COMUNS_NORTE, CARDS_RAROS_NORTE } from "./cartas";
import fundoColecao from "./colecao.webp";
import mascoteCabeca from "./mascote-cabeca.webp";
import mascoteCorpo from "./mascote-corpo.webp";
import fundoSelecao from "./selecao.webp";
import fundoDesfocado from "./tabuleiro-desfocado.webp";
import fundoTabuleiro from "./tabuleiro.webp";

// Região NORTE, bioma Amazônia, mascote Onça-pintada.
//
// O id é `norte`, e não `amazonia`: a região geográfica É a região do bioma, e há um
// nome só (decisão do Kilson em 05/08/2026). "Amazônia" é o `bioma`, rótulo que o
// aluno lê. Consequência: os `card_id` são `norte-*`, embora
// `TemasDaTrilhas/norte/MD_Texto/Cards_Curiosidade_Amazonia.md` proponha `amazonia-*`
// — aquele documento está SUPERADO nesse ponto, e `card_id` é chave da coleção do
// aluno no banco.
//
// A PASTA É A REGIÃO: descritor, cartas e toda a arte moram aqui, e nenhum nome de
// arquivo repete o id (`tabuleiro.webp`, não `trilha-bg-<regiao>-horizontal.webp`).
// Acrescentar uma região é encher uma pasta destas e escrever uma linha em
// `../index.js`; apagar uma é apagar a pasta. Ver "Como acrescentar uma região" no
// README do módulo.

export const MASCOTE_NORTE = {
  nome: "Onça-pintada",
  // corpo: momento "hero" (apresentação, encerramento).
  // cabeca: enquadramento fechado, para os slots pequenos (balão de fala de 80px e
  // o medalhão de 56px do nó de recompensa). RECORTADA da arte de corpo inteiro, e
  // não do `cabeca_onca.webp` que veio na pasta — aquele tem disco branco de fundo,
  // e no `object-fit: cover` de 80px apareceria como um círculo branco.
  corpo: mascoteCorpo,
  cabeca: mascoteCabeca,
  // Ela fala no FEMININO, ao contrário do Tatu-bola. Não é detalhe de estilo:
  // "sozinha" no card de ajuda depende disto para não soar errado.
  fala: "Oi, explorador(a)! Sou a Onça-pintada, a maior caçadora da Amazônia — e ainda assim minha espécie está ameaçada. Encara os desafios comigo e descubra como proteger meu lar. Bora?",
  // A fala do ENCERRAMENTO, quando o álbum das cartas está na tela.
  //
  // NÃO CONTA AS CARTAS, e isso é regra e não estilo: numa trilha de 2 passos existe
  // uma única fase premiada, então o aluno termina com UMA carta — e essa é a trilha
  // mais curta que o professor pode montar, ou seja a mais provável de existir.
  // Qualquer frase que diga "essas cartas" fica errada justamente ali. Com a fala
  // número-agnóstica o erro de plural é impossível por construção, em vez de depender
  // de quem escrever a próxima região lembrar do caso. Quem conta é o cromo, acima do
  // álbum.
  //
  // "Olha o que você descobriu" APONTA para o álbum logo abaixo em vez de descrevê-lo
  // — a imagem faz metade do trabalho, que é o recurso mais barato para quem está
  // aprendendo a ler. E o feminino vem num adjetivo sobre a PRÓPRIA onça
  // ("tranquila"), não sobre a Amazônia: assim a concordância não sobrevive por acaso
  // se alguém trocar o bioma da frase.
  falaEncerramento:
    "Olha o que você descobriu na minha floresta. Fico mais tranquila sabendo que a Amazônia tem você por perto.",
  // O galho de álbum vazio — o aluno chegou ao fim sem carta nenhuma. Não menciona
  // carta, porque a tela não mostra nenhuma: celebra o percurso, que é real, e deixa
  // uma porta que também é verdadeira (refazer a trilha sorteia cartas novas do banco
  // de 20 comuns). Nada de prometer "próxima trilha", que é decisão do professor e já
  // está dita na nota logo abaixo.
  falaEncerramentoSemCartas:
    "Você atravessou a minha floresta inteira. Estou orgulhosa, e ainda tenho muita coisa pra te mostrar aqui."
};

export const TABULEIRO_NORTE = {
  fundo: fundoTabuleiro,
  // ARTE DO ILUSTRADOR, entregue à parte em 05/08/2026 (clareira com rio,
  // 2752x1536) — NÃO é derivada do tile. `gerar-fundo-trilha.py --desfocado` se
  // RECUSA a sobrescrevê-la; ver `fundo_desfocado_fornecido` no catálogo, e o motivo
  // registrado lá: o script existe para ser rodado de novo, e cada rodada apagava a
  // arte entregue.
  fundoDesfocado,
  // Idem — arte própria da região, não derivada. É o fundo das etapas de escolher o
  // explorador e de apresentação do mascote.
  fundoSelecao,
  fundoColecao,
  proporcao: 2.2202,
  // Medido em 05/08/2026 pelo método do CAMINHO, e não pelo centro de massa que a
  // Caatinga usa: aqui a clareira é larga e trançada, então a média da massa de
  // barro caía no meio de uma faixa que tem barro acima e abaixo — e o meio, em
  // alguns trechos, é uma ilha de vegetação. Ver o cabeçalho de
  // `gerar-perfil-estrada.py`.
  //
  // 30,1% a 54,5% da altura; salto na emenda 2,4pp; pior par de vizinhas 4,3pp; as
  // 192 posições conferidas caem sobre o chão.
  perfilDaEstrada: [
    46.2, 40.1, 33.2, 29.0, 27.9, 30.4, 33.9, 38.9, 44.6, 49.1, 52.0, 53.1,
    53.0, 52.4, 50.5, 48.7, 47.7, 47.1, 45.8, 44.6, 44.0, 43.4, 45.7, 47.6,
    47.3, 47.0, 46.6, 42.1, 39.3, 39.3, 39.8, 40.9, 42.3, 42.8, 44.2, 45.8,
    47.4, 49.8, 51.4, 50.3, 49.0, 47.8, 47.7, 48.2, 51.8, 54.3, 53.7, 51.1
  ]
};

export const CORES_NORTE = {
  // O accent é o OURO DO PELO DA ONÇA (#e0a030, a cor dominante da arte do
  // mascote), e ele é quente de propósito: aparece na borda do explorador
  // escolhido e na região destacada do mapa, sempre sobre uma paleta verde. Um
  // accent verde desapareceria contra o próprio cenário — foi o motivo de não usar
  // o verde da mata, que seria o palpite óbvio.
  region: "#e0a030",
  regionStrong: "#9a6a14",
  // O degradê da casca acompanha a ordem de claridade da Caatinga (claro → médio →
  // escuro), com as cores da floresta: luz filtrada pelo dossel, musgo, e o chão
  // na sombra. A base é próxima do que a arte tem na borda de baixo (medido:
  // #32321f).
  fundoTopo: "#e8f0d2",
  fundoMeio: "#a3bd72",
  // Era #33401f, e subiu em 05/08/2026 junto com o clareamento do tile: a base do
  // degradê é a parte de baixo da casca, e ela ficava a 19% de claridade contra os
  // 25% da Caatinga — o tabuleiro clareava e a moldura em volta continuava escura.
  // 25% é o alvo porque é o valor da região que já está aprovada para este público.
  fundoBase: "#44552a",
  // O véu sobre a ilustração embaçada do `::before`: as três de cima com alfa, nas
  // mesmas opacidades da Caatinga.
  veuTopo: "rgba(232, 240, 210, 0.5)",
  veuMeio: "rgba(163, 189, 114, 0.3)",
  // Acompanha a base do degradê, e com 0,42 de alfa em vez de 0,55: este véu cai
  // sobre a ilustração EMBAÇADA, que é o que aparece em volta do tabuleiro, e um
  // verde muito escuro a 55% escurecia a moldura exatamente na altura em que o
  // cenário já tinha clareado.
  veuBase: "rgba(68, 85, 42, 0.42)",
  // O véu radial da escolha do explorador. VERDE e mais fraco que o da Caatinga
  // (0,35/0,18/0,10 contra 0,5/0,25/0,1), por dois motivos: o areia da Caatinga
  // sobre a floresta apagava o verde e devolvia um oliva acinzentado — visto no app
  // —, e esta arte já chegou clara e acabada do ilustrador, então precisa de menos
  // véu para o painel dos exploradores se destacar dela.
  veuSelecaoCentro: "rgba(232, 240, 210, 0.35)",
  veuSelecaoMeio: "rgba(163, 189, 114, 0.18)",
  veuSelecaoBorda: "rgba(51, 64, 31, 0.1)",
  // O cromo (setas de navegação, pílula do contador) é VERDE-FLORESTA, e aqui ele
  // DIVERGE do accent de propósito. O accent é o ouro da onça (#e0a030) porque
  // aparece sobre o degradê verde da casca e precisa contrastar com ele; o cromo
  // aparece sobre o CENÁRIO, numa pílula/círculo BRANCO, e ali o ouro ficava
  // indistinguível do dourado de prêmio que as estrelas dos nós usam — duas coisas
  // com significados diferentes na mesma tela e na mesma cor.
  //
  // Verde escuro sobre branco tem contraste de sobra para o chevron da seta e para o
  // texto "Fase 3 de 8", e diz Amazônia sem competir com a estrela.
  chromeBorda: "#4f9d3a",
  chromeTexto: "#2f6b3a",
  chromeFundo: "#e6f4dd"
};

// A FIGURA DO ARCO, na ordem de `cardsRaros` — ameaça primeiro, fecho por último.
//
// É a cena que o aluno vê no fim de leva quando a carta rara NÃO é sorteada (ver
// `cenaDaFase` em ../../../nucleo/recompensaDaFase.js): o mascote cabisbaixo na
// ameaça, de braços erguidos na ajuda, e nenhum prêmio.
//
// SÓ A ARTE, e é o ponto. Nome e fala do arco não estão aqui porque já existem: são
// os da carta que teria caído ali. Uma segunda cópia do texto no descritor
// divergiria da primeira no dia em que alguém ajustasse uma pílula em
// `TemasDaTrilhas/`, que é a fonte de verdade e de onde `gerar-cartas-trilha.py`
// gera `cartas.js`.
//
// LISTA E NÃO `{ ameaca, ajuda }`: quem casa fase rara com momento do arco é o
// alinhamento pelo fim, que trabalha com ÍNDICE. Com um objeto de dois nomes, o
// núcleo teria de saber que o índice 0 se chama "ameaca" — ou seja conheceria a
// narrativa da região, que é exatamente o que ele não faz.
//
// Derivada por `ferramentas-da-trilha/gerar-figuras-trilha.py` (modo `arco`) da arte
// da carta rara: fora a moldura de madeira, e a borda dissolvida.
export const ARCO_NORTE = [arcoAmeaca, arcoAjuda];

export const REGIAO_NORTE = {
  id: "norte",
  nome: "Norte",
  bioma: "Amazônia",
  mascote: MASCOTE_NORTE,
  cardsComuns: CARDS_COMUNS_NORTE,
  cardsRaros: CARDS_RAROS_NORTE,
  arco: ARCO_NORTE,
  tabuleiro: TABULEIRO_NORTE,
  cores: CORES_NORTE
};

// Reexportado para quem já importava daqui antes de as cartas saírem para
// `./cartas.js` — e porque o teste das regiões pede o conjunto.
export { CARDS_COMUNS_NORTE, CARDS_RAROS_NORTE, CARDS_NORTE } from "./cartas";
